import { FinalPlan, PlanData, PlanPeriod } from 'components';

/**
 * Determines if a plan is the user's current active plan for the selected period
 *
 * @param plan - The plan data to check
 * @param selectedPeriod - The billing period to check against ('monthly' or 'annual')
 * @returns true if the plan is the user's current plan for the selected period
 */
export function isCurrentUserPlan(plan: FinalPlan | null | undefined, selectedPeriod: PlanPeriod): boolean {
    if (!plan || !plan.currentUserPlan) {
        return false;
    }

    // Plan must be marked as current
    if (!plan.isCurrentPlan) {
        return false;
    }

    // Check if it matches the selected billing period
    if (selectedPeriod === 'monthly') {
        return plan.currentUserPlan.isCurrentMonthly === true;
    }

    if (selectedPeriod === 'annual') {
        return plan.currentUserPlan.isCurrentAnnual === true;
    }

    return false;
}
